import {
  ASSIST_PRODUCT_KEY,
  CLAIM_REASONS_FLAG,
  SHIPPING_PROTECTION_PRODUCT_KEY,
} from '../constants/returnReasonSets';
import { growthbook } from '../growthbook';

// Whether the current retailer carries the given product.
export const retailerHasProduct = (state, productKey) => {
  try {
    const { user } = state.userReducer;
    const products =
      (user.retailerIdToRetailerInfo[user.retailerId] || {}).products || [];
    return products.some(
      product => (product || '').toLowerCase() === productKey,
    );
  } catch (err) {
    return false;
  }
};

// Whether the retailer has the delivery-protection (Secure) product. This drives the coverable
// hints.
export const retailerHasShippingProtection = state =>
  retailerHasProduct(state, SHIPPING_PROTECTION_PRODUCT_KEY);

// Whether the retailer is entitled to claim authoring by product alone. A retailer with the assist
// product or the shipping-protection product qualifies. This is the part of the gate that the
// GrowthBook flag does not control, so it is stable across a flag change.
export const retailerEntitledForClaims = state =>
  retailerHasProduct(state, ASSIST_PRODUCT_KEY) ||
  retailerHasShippingProtection(state);

// The editor offers the claim product type to a retailer that has the assist product or the
// shipping-protection product, and that has the GrowthBook flag on. A Secure-only retailer
// (shipping_protection, no assist) also gets it. If the retailer fails either condition, the editor
// removes "claim" from the Product Type options, so an unflagged retailer sees no change.
export const isClaimAuthoringEnabled = state =>
  retailerEntitledForClaims(state) && growthbook.isOn(CLAIM_REASONS_FLAG);
